<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
        <template v-if="records && records.length">
          <table class="table table-hover table-sm">
            <tbody>
            <tr v-for="(o, i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>
                <p>{{ o.client_name }}</p>
                <template v-for="p in o.search_phones">
                  <p>{{ p }}</p>
                </template>
              </td>
              <td>{{ o.order_data.order_id }}</td>
              <td>
                <p v-for="d in o.order_data.drugs">{{ d.title }} x <strong>{{ d.requestQty }}</strong> x
                  <strong>{{ d.price }}</strong></p>
              </td>
              <td>{{ o.price }}</td>
              <td><p>{{ printDate(o.created_at) }}</p>
                <p>{{ o.catalog_order_id}}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'

export default {
  components: {
    Paginate,
  },
  data() {
    return {
      records: [],
      loading: false,
      paginator: null,
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.index('/new/orders/outsource?page=' + page)
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.records = data
      } else {
        toastr['warning'](r_data.message || 'Ошибка сервера');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table p {
  margin-bottom: 2px;
}
</style>
